export const useAppConfig = (): { byPassAuth: boolean } => {
    const byPassAuth =
        (process.env.NODE_ENV === 'development' &&
            typeof process.env.REACT_APP_BYPASS_AUTH !== 'undefined') ||
        false

    return { byPassAuth }
}
